import { publicRequest } from '@/utils/request'

export function login(username, password) {
  return publicRequest({
    url: '/sso/login',
    method: 'post',
    params: {
      username,
      password
    }
  })
}

export function getInfo() {
  return publicRequest({
    url: '/sso/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function sendEmailCode(email) {
  const formData = new URLSearchParams()
  formData.append('email', email)
  return publicRequest({
    url: '/sso/sendEmailCode',
    method: 'post',
    data: formData.toString(),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function sendResetPasswordEmailCode(email) {
  const formData = new URLSearchParams()
  formData.append('email', email)
  return publicRequest({
    url: '/sso/sendResetPasswordEmailCode',
    method: 'post',
    data: formData.toString(),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function resetPasswordByEmail(data) {
  const formData = new URLSearchParams()
  Object.keys(data).forEach(key => {
    if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
      formData.append(key, data[key])
    }
  })
  return publicRequest({
    url: '/sso/resetPasswordByEmail',
    method: 'post',
    data: formData.toString(),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function createAdmin(data) {
  // 使用 URLSearchParams 构建表单数据
  const formData = new URLSearchParams();
  Object.keys(data).forEach(key => {
    if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
      formData.append(key, data[key]);
    }
  });
  
  return publicRequest({
    url: '/sso/register',
    method: 'post',
    data: formData.toString(), // 转换为字符串格式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [(data) => {
      // 确保数据以表单格式发送
      return data;
    }]
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js